import { render, staticRenderFns } from "./ServiciosInternacionales.vue?vue&type=template&id=c2530c9c&"
import script from "./ServiciosInternacionales.vue?vue&type=script&lang=js&"
export * from "./ServiciosInternacionales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports